// Hide pagination for JS users
document.documentElement.classList.add('js');

(function () {
  console.log('[InfiniteScroll] boot');

  // ===== CONFIG =====
  const SCROLL_PERCENT_THRESHOLD = 0.50; // load when user reaches 50%
  const SCROLL_DEBOUNCE_MS       = 150;
  const IO_BOTTOM_MARGIN_PX      = 400;
  const APPEND_DELAY_MS          = 100;  // wait a tick before appending
  const FACETS_REINIT_DELAYS     = [600, 2000]; // retry widget init after facets

  // ===== STATE =====
  const state = {
    grid: null,
    trigger: null,
    btn: null,
    nextURL: null,
    lastLoadedURL: null,
    loading: false,
    done: false,
    io: null,
    scrollHandler: null,
    resizeHandler: null,
    controller: null,    // AbortController for fetch
    token: 0,            // session token to discard stale responses
  };

  // Expose helpers for quick console tests
  window.__infiniteScrollLoadNext = loadNext;
  window.__infiniteScrollReinit   = init;

  // Initial bind
  init();

  // Re-init when Dawn replaces the grid after filters/sorting/back button
  document.addEventListener('facets:updated', onFacetsUpdated);
  window.addEventListener('popstate', init);

const gridContainer = document.querySelector('#ProductGridContainer');
if (gridContainer && !gridContainer.__isObserved) {
  const mo = new MutationObserver((muts) => {
    // Ignore mutations we cause while appending
    if (state.appending) return;

    // Only react when the grid container's direct children are replaced
    const replaced = muts.some(m => m.type === 'childList' && m.target === gridContainer);
    if (!replaced) return;

    // Debounce re-init
    if (window.__infScrollPending) return;
    window.__infScrollPending = true;
    setTimeout(() => { init(); window.__infScrollPending = false; }, 50);
  });

  // Watch only direct childList changes (no subtree) to avoid loops
  mo.observe(gridContainer, { childList: true });
  gridContainer.__isObserved = true;
}


  // ===== INIT / TEARDOWN =====
  function init() {
    teardown();

    state.grid    = document.querySelector('#product-grid');
    state.trigger = document.querySelector('#infinite-scroll-trigger');
    state.btn     = document.querySelector('#load-more-btn');

    if (!state.grid || !state.trigger) {
      console.warn('[InfiniteScroll] Missing grid or trigger', { grid: !!state.grid, trigger: !!state.trigger });
      return;
    }

    // cancel any in-flight request, bump session token
    if (state.controller) try { state.controller.abort(); } catch {}
    state.controller = null;
    state.token++;

    state.nextURL       = getNextURL(document);
    state.lastLoadedURL = null;
    state.loading       = false;
    state.done          = !state.nextURL;

    console.log('[InfiniteScroll] init nextURL =', state.nextURL, 'token:', state.token);
    // Kick widgets on first paint too (some apps need a short delay)
    setTimeout(reinitWidgets, 400);
    setTimeout(reinitWidgets, 1800); // safety retry for slower apps
    // Button wiring
    if (state.btn) {
      state.btn.onclick = () => { setBtnVisible(false); loadNext(); };
      setBtnVisible(false);
    }

    // Debounced scroll-percentage trigger
    let ticking = false;
    let debounceTimer;
    state.scrollHandler = () => {
      if (state.done || state.loading) return;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          const doc = document.documentElement;
          const body = document.body;
          const dh = Math.max(
            body.scrollHeight, doc.scrollHeight,
            body.offsetHeight, doc.offsetHeight,
            body.clientHeight, doc.clientHeight
          );
          const vh  = window.innerHeight || doc.clientHeight;
          const st  = window.pageYOffset || doc.scrollTop || body.scrollTop || 0;
          const pct = (st + vh) / dh;

          if (pct >= SCROLL_PERCENT_THRESHOLD) loadNext();
          if (!state.loading && !state.done && state.nextURL && pct >= 0.98) setBtnVisible(true);

          ticking = false;
        });
      }, SCROLL_DEBOUNCE_MS);
    };
    state.resizeHandler = state.scrollHandler;

    window.addEventListener('scroll', state.scrollHandler, { passive: true });
    window.addEventListener('resize', state.resizeHandler);

    // IO fallback (preload near bottom)
    state.io = new IntersectionObserver((entries) => {
      const e = entries && entries[0];
      if (!e || !e.isIntersecting || state.done || state.loading) return;
      loadNext();
    }, { rootMargin: `0px 0px ${IO_BOTTOM_MARGIN_PX}px 0px` });
    state.io.observe(state.trigger);

    ensureSpinner();
  }

  function teardown() {
    try { state.io && state.io.disconnect(); } catch {}
    try {
      if (state.scrollHandler) window.removeEventListener('scroll', state.scrollHandler);
      if (state.resizeHandler) window.removeEventListener('resize', state.resizeHandler);
    } catch {}
    if (state.controller) { try { state.controller.abort(); } catch {} state.controller = null; }
    state.io = null;
    state.scrollHandler = null;
    state.resizeHandler = null;
  }

  function onFacetsUpdated() {
    // Rebind first (bump token & cancel any in-flight), then reinit widgets after a short delay
    init();
    FACETS_REINIT_DELAYS.forEach(d => setTimeout(reinitWidgets, d));
  }

  // ===== MAIN LOADER =====
  async function loadNext() {
    if (state.done || state.loading || !state.nextURL) return;
    if (state.nextURL === state.lastLoadedURL) { state.done = true; cleanup(); return; }

    // mark as loading; create a new controller and capture current token
    state.loading = true;
    setBtnVisible(false);
    showSpinner(true);
    const myToken = state.token;
    state.controller = new AbortController();

    console.log('[InfiniteScroll] Fetching:', state.nextURL, 'token:', myToken);

    try {
      const res = await fetch(state.nextURL, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        signal: state.controller.signal,
      });
      if (!res.ok) throw new Error('Network ' + res.status);
      const html = await res.text();

      // discard if token changed (new init happened while we were fetching)
      if (myToken !== state.token) {
        console.warn('[InfiniteScroll] stale response discarded (token changed)');
        return;
      }

      const doc  = new DOMParser().parseFromString(html, 'text/html');
      const newGrid = doc.querySelector('#product-grid');
      if (!newGrid) {
        console.warn('[InfiniteScroll] next page grid not found');
      } else {
        state.appending = true;
        // wait a tick so Dawn/facets settles
        await delay(APPEND_DELAY_MS);

        // Build a set of existing product hrefs (de-dupe)
        const hrefSet = new Set(
          Array.from(state.grid.querySelectorAll('a[href*="/products/"]'))
            .map(a => a.getAttribute('href'))
        );

        // Move children to a fragment first (atomic append)
        const frag = document.createDocumentFragment();
        while (newGrid.firstElementChild) {
          const li = newGrid.firstElementChild;
          // try to find the main product link inside this card
          const link = li.querySelector('a[href*="/products/"]');
          const href = link && link.getAttribute('href');
          if (href && hrefSet.has(href)) {
            // skip duplicates
            newGrid.removeChild(li);
            continue;
          }
          try {
            frag.appendChild(li);
            if (href) hrefSet.add(href);
          } catch (e) {
            console.warn('[InfiniteScroll] skipped one item while staging', e);
            newGrid.removeChild(li);
          }
        }

        // Append in one shot (prevents half-rows)
        state.grid.appendChild(frag);

        // Ensure images are decoded to avoid layout thrash
        const imgs = state.grid.querySelectorAll('img');
        for (const img of imgs) {
          if (!img.complete) { try { await img.decode(); } catch {} }
        }

        // Reinit theme features (quick add etc.)
        reinitWidgets();

        // Now, explicitly (and only now) init the Back-in-Stock widget AFTER append finishes
        await initBackInStockAfterAppend();

        document.dispatchEvent(new CustomEvent('infinite:append'));

        state.appending = false;
      }

      // Move forward the next-page holder
      const currentHolder  = document.querySelector('#next-page-url');
      const incomingHolder = doc.querySelector('#next-page-url');
      if (currentHolder) currentHolder.remove();
      if (incomingHolder) document.body.appendChild(incomingHolder.cloneNode(true));

      state.lastLoadedURL = state.nextURL;
      state.nextURL       = getNextURL(document);
      console.log('[InfiniteScroll] new nextURL =', state.nextURL);

      if (!state.nextURL || state.nextURL === state.lastLoadedURL) {
        state.done = true;
        cleanup();
      }
    } catch (err) {
      if (err && err.name === 'AbortError') {
        console.warn('[InfiniteScroll] fetch aborted (likely re-init)');
        return;
      }
      console.error('[InfiniteScroll] error:', err);
      if (!state.done) setBtnVisible(true); // let user click “Show more”
    } finally {
      if (myToken === state.token) {
        state.loading = false;
        showSpinner(false);
        state.controller = null;
      }
    }
  }

  // ===== HELPERS =====
  function getNextURL(scope) {
    // 1) our data holder
    const holder = scope.querySelector('#next-page-url');
    const dataNext = holder && holder.getAttribute('data-next-url');
    if (dataNext) return new URL(dataNext, location.origin).toString();

    // 2) rel=next (if present)
    const rel = scope.querySelector('link[rel=next]');
    if (rel && rel.href) return rel.href;

    // 3) fallback: pagination next anchor (even if hidden by CSS)
    const a = scope.querySelector('.pagination__item--next a, .pagination .next a, a[rel="next"]');
    return a && a.href ? a.href : null;
  }

  function ensureSpinner() {
    let spinner = document.getElementById('infinite-spinner');
    if (!spinner && state.trigger) {
      spinner = document.createElement('div');
      spinner.id = 'infinite-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      spinner.style.cssText = 'width:100%;display:none;justify-content:center;padding:16px 0;';
      spinner.innerHTML = '<div style="width:28px;height:28px;border-radius:50%;border:3px solid currentColor;border-top-color:transparent;animation:spin 1s linear infinite;"></div>';
      state.trigger.insertAdjacentElement('beforebegin', spinner);

      if (!document.getElementById('infspin-style')) {
        const style = document.createElement('style');
        style.id = 'infspin-style';
        style.textContent = '@keyframes spin { to { transform: rotate(360deg); } }';
        document.head.appendChild(style);
      }
    }
  }

  function showSpinner(show) {
    ensureSpinner();
    const spinner = document.getElementById('infinite-spinner');
    if (spinner) spinner.style.display = show ? 'flex' : 'none';
  }

  function setBtnVisible(show) {
    const btn = document.getElementById('load-more-btn');
    if (btn) btn.style.display = show ? 'block' : 'none';
  }

  function delay(ms) { return new Promise(r => setTimeout(r, ms)); }

  function reinitWidgets() {
    try {
      // Dawn quick add / other theme features
      if (window.BulkAdd && typeof window.BulkAdd.init === 'function') window.BulkAdd.init();
      document.dispatchEvent(new Event('shopify:section:load'));

      // Back-in-stock widgets (try common providers; no-op if not present)
      if (window.BIS && typeof window.BIS.init === 'function') window.BIS.init();
      if (window.AppstleReStock && typeof window.AppstleReStock.init === 'function') window.AppstleReStock.init();
      if (window.BackInStock && typeof window.BackInStock.init === 'function') window.BackInStock.init();

      // Klaviyo forms sometimes need this
      if (window._learnq && typeof window._learnq.push === 'function') {
        try { window._learnq.push(['formListeners']); } catch {}
      }

      console.log('[InfiniteScroll] widgets reinitialized');
    } catch (e) {
      console.warn('[InfiniteScroll] widget reinit skipped', e);
    }
  }

  function cleanup() {
    teardown();
    setBtnVisible(false);
    try { document.getElementById('infinite-scroll-trigger')?.remove(); } catch {}
    try { document.getElementById('infinite-spinner')?.remove(); } catch {}
    document.dispatchEvent(new Event('infinite:done'));
    console.log('[InfiniteScroll] done');
  }
  window.addEventListener('load', () => {
  setTimeout(reinitWidgets, 300);
  });
// Wait until a Back-in-Stock widget is actually present, then init it
async function waitForBISReady(timeoutMs = 6000) {
  const start = Date.now();
  return new Promise((resolve) => {
    const check = () => {
      const ready =
        (window.BIS && typeof window.BIS.init === 'function') ||
        (window.AppstleReStock && (typeof window.AppstleReStock.init === 'function' || typeof window.AppstleReStock.load === 'function')) ||
        (window.BackInStock && typeof window.BackInStock.init === 'function') ||
        (window.AppikonBackInStock && typeof window.AppikonBackInStock.init === 'function');

      if (ready) return resolve(true);
      if (Date.now() - start > timeoutMs) return resolve(false);
      setTimeout(check, 200);
    };
    check();
  });
}

async function initBackInStockAfterAppend() {
  // fire common signals first (some apps listen for these)
  try {
    document.dispatchEvent(new Event('shopify:section:load'));
    document.dispatchEvent(new Event('infinite:append'));
    document.dispatchEvent(new Event('back-in-stock:refresh'));
  } catch {}

  const ok = await waitForBISReady(6000);
  if (!ok) {
    console.warn('[InfiniteScroll] BIS not ready after append (6s)');
    return;
  }

  try {
    if (window.BIS && typeof window.BIS.init === 'function') {
      console.log('[InfiniteScroll] BIS.init()');
      window.BIS.init();
    }
    if (window.AppstleReStock) {
      if (typeof window.AppstleReStock.init === 'function') {
        console.log('[InfiniteScroll] AppstleReStock.init()');
        window.AppstleReStock.init();
      } else if (typeof window.AppstleReStock.load === 'function') {
        console.log('[InfiniteScroll] AppstleReStock.load()');
        window.AppstleReStock.load();
      }
    }
    if (window.BackInStock && typeof window.BackInStock.init === 'function') {
      console.log('[InfiniteScroll] BackInStock.init()');
      window.BackInStock.init();
    }
    if (window.AppikonBackInStock && typeof window.AppikonBackInStock.init === 'function') {
      console.log('[InfiniteScroll] AppikonBackInStock.init()');
      window.AppikonBackInStock.init();
    }
  } catch (e) {
    console.warn('[InfiniteScroll] BIS init after append failed', e);
  }
}


})();
